import { render, staticRenderFns } from "./OrganisationsUpdateModal.vue?vue&type=template&id=ad61b624&"
import script from "./OrganisationsUpdateModal.vue?vue&type=script&lang=js&"
export * from "./OrganisationsUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports